/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/08/31 17:29:18
*/
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
@Component({
    components: {

    }
})
export default class NvSelect extends BaseVue {

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区
    /**
     * label
     * icon
     * text
     */
    @Prop({ default: () => ([]) })
    selectItems?: any[];

    @Prop({ default: '' })
    value: any;

    selectValue: any = "";

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {

    }

    //#endregion 事件定义区

    //#region 方法定义区

    @Watch("value")
    valueChange(val) {
        this.selectValue = val;
    }

    doselectChange() {
        this.$emit('input', this.selectValue);
    }

    //#endregion 方法定义区
}